import React, { Component } from 'react';
import { connect } from 'react-redux';

//Actions
import { addToast } from '../../../../common/modules/toasts/ToastsActions';
import {
  apiGetVehiclePromotion,
  apiGetVehicles,
  apiGetVehiclesSearch,
  clearDataVehicles,
  filterVehicles,
  orderByLowerPrice,
  orderByMorePrice,
  orderByOffersAndPromotions, setVehiclesState
} from '../../../../common/modules/vehicles/VehiclesActions';
import { addComparator } from '../../../../common/modules/comparator/ComparatorActions';

//Components
import { Modal } from '../../components/Modal';
import ModalReservation from './ModalReservation';
import VehiclesItems from './components/VehiclesItems';
import VehiclesFilter from './components/VehiclesFilter';

// Resources
import {
  toggleModal,
  closeModalBackdrop,
  removeTooltips,
  startSelectPicker,
  startTooltips,
  refreshSelectPicker,
} from '../../resources/styles/js/custom';
import VehiclesManager from '../../../../common/modules/vehicles/VehiclesManager';
import { strings } from '../../../../common/resources/locales/i18n';
import { Loading } from '../../components';
import VehiclesFilterManager, { filterTypeVehicles } from '../../../../common/modules/vehicles/VehiclesFilterManager';
import Routing from '../routing/Routing';
import { addPixelFacebook, getVinPixelFacebook, legalScripts_VehiclesContainer } from '../../../../common/utils/Utils';
import { Link } from 'react-router-dom';
import {getAsset} from "../../../../common/resources/assets/assets";
import {ImageSvg} from "../../components/ImageSvg";

class VehiclesContainer extends Component {

  state = {
    vehicle: {},
    inputOrderValue: '0'
  }

  async componentDidMount() {
    const { metasModelTitle, currentModelDescription, metasModelDescription, cookiesBannerScript, metricsGtmEnabled, metricsGtmId } = this.props;

    if (legalScripts_VehiclesContainer) {
      legalScripts_VehiclesContainer({
        metasModelTitle, currentModelDescription,
        metasModelDescription, cookiesBannerScript,
        metricsGtmEnabled, metricsGtmId
      });
    }

    await this._clearDataVehicles();
    await this._loadVehicles();
    this._getVehiclesFilter();
    await this._orderByLowerPrice();
    startTooltips();
    startSelectPicker();

    const {dataVehicles} = this.props;
    if (addPixelFacebook) addPixelFacebook(false, false, getVinPixelFacebook(dataVehicles));
  }

  async componentDidUpdate(prevProps) {
    const {
      idParams, match, metasModelTitle, currentModelDescription,
      metasModelDescription, cookiesBannerScript, metricsGtmEnabled, metricsGtmId, location
    } = this.props;
    const search = idParams;
    const prevPropsSearch = prevProps.idParams;
    const isPromotion = match.path.includes(Routing.vehiclePromotion)

    if (legalScripts_VehiclesContainer) {
      legalScripts_VehiclesContainer({
        metasModelTitle, currentModelDescription,
        metasModelDescription, cookiesBannerScript,
        metricsGtmEnabled, metricsGtmId
      });
    }

    if (search !== prevPropsSearch && location && location.pathname && location.pathname.includes('search=') ) {
      await this._apiGetVehiclesSearch();
      await this._orderByLowerPrice();
      startTooltips();
      startSelectPicker();
    } else if (prevProps.match && prevProps.match.path && match && match.path && prevProps.match.path !== match.path ) {
      await this._clearDataVehicles();
      if (isPromotion){
        await this._apiGetVehiclePromotion();
        await this._orderByLowerPrice();
      }
      if (match.path.includes(Routing.vehicle) || match.path === Routing.vehiclesAllStock){
        await this._apiGetVehicles();
        await this._orderByLowerPrice();
      }
      this._getVehiclesFilter();
    }

    const {dataVehicles} = this.props;
    if (addPixelFacebook) addPixelFacebook(false, false, getVinPixelFacebook(dataVehicles));
  }

  componentWillUnmount() {
    this._clearDataVehicles();
  }

  render() {
    const { idParams, currentModelH2Label, currentModelH2Paragraph, allVehiclesH2Title, allVehiclesPSubtitle, dataVehicles, dataVehiclesOriginal } = this.props
    const h2Label = idParams ? currentModelH2Label : allVehiclesH2Title
    const h2Paragraph = idParams ? currentModelH2Paragraph : allVehiclesPSubtitle
    const textLabelParagraph = (
      <div className='mt-3'>
        <h2 className='h4 mb-0 text-secondary'>{h2Label}</h2>
        <p className='mb-0 text-dark'>{h2Paragraph}</p>
      </div>
    )

    let showTextLabelParagraph = <></>
    if (idParams && dataVehicles?.length > 0) {
      showTextLabelParagraph = textLabelParagraph
    } else if (dataVehiclesOriginal?.length > 0) {
      showTextLabelParagraph = textLabelParagraph
    }


    return (
      <>
        <main id="main" role="main">
          <section id="all-models" className="py-3 py-lg-4 mb-5">
            <div className="container">
              {this._renderTopBar()}
              <div className="row pt-2">
                {this._renderVehicleEmptyList()}
                <div className="col-xl-3 d-none d-xl-block">
                  <div id="sidebar-filters" className="sticky-top" style={{ top: 96 }}>
                    {this._renderVehicleFilter()}
                  </div>
                </div>

                <div className="col-lg-9">
                  {this._renderVehicleList()}
                  {showTextLabelParagraph}

                </div>

              </div>
            </div>
          </section>
        </main>
        <button className="d-none" data-toggle="modal" data-target="#modalAddComparator" id='idAddComparator'/>
        {this._renderVehicleModalComparator()}
        <ModalReservation vehicle={this.state.vehicle} history={this.props.history}/>
      </>
    );
  }

  /** PRIVATE METHOD **/
  async _addComparator(vehicle) {
    const { dataComparator, vehiclesCompareMax } = this.props;
    if (dataComparator && dataComparator.length === parseInt(vehiclesCompareMax)) {
      toggleModal('idAddComparator');
    } else {
      await this.props.addComparator(vehicle);
      removeTooltips();
    }
  }

  async _apiGetVehicles() {
    const { idParams } = this.props;

    await this.props.apiGetVehicles(idParams);
    //startCarousel();
  }

  async _apiGetVehiclePromotion() {
    const { idParams } = this.props;
    await this.props.apiGetVehiclePromotion(idParams);
    startSelectPicker()
    //startCarousel();
  }

  async _apiGetVehiclesSearch() {
    const { apiGetVehiclesSearch, location } = this.props;
    let search = false;
    if (location && location.pathname) {
      const split = location.pathname.split('=');
      search = split && split.length === 2 ? split[1] : false;
    }
    if (search) {
      await apiGetVehiclesSearch(search);
      startSelectPicker();
      //startCarousel();
    }
  }

  async _clearDataVehicles() {
    await this.props.clearDataVehicles();
  }

  _getVehiclesFilter() {
    const { availableFilters, queryParams, maxPrice, minPrice, maxCuota, minCuota, } = this.props;

    const price = queryParams.get(filterTypeVehicles.PRICE);
    const specialPrice = queryParams.get(filterTypeVehicles.SPECIAL_PRICE);
    const colors = queryParams.get(filterTypeVehicles.COLORS);
    const fuels = queryParams.get(filterTypeVehicles.FUELS);
    const transmissions = queryParams.get(filterTypeVehicles.TRANSMISSIONS);
    const cuota = queryParams.get(filterTypeVehicles.CUOTA);

    if (cuota && minCuota <= cuota && cuota <= maxCuota) {
      this._handleValueChange('cuota', cuota);
    }

    if (price && minPrice <= price && price <= maxPrice) {
      this._handleValueChange('price', price);
    }

    if (specialPrice && specialPrice === 'true') {
      this._handleValueChange('specialPrice', specialPrice === 'true');
    }

    if (colors && VehiclesFilterManager.getFilterValueByCode(availableFilters, filterTypeVehicles.COLORS, colors)) {
      this._handleValueChange('colors', colors);
    }

    if (fuels && VehiclesFilterManager.getFilterValueByCode(availableFilters, filterTypeVehicles.FUELS, fuels)) {
      this._handleValueChange('fuels', fuels);
    }

    if (transmissions && VehiclesFilterManager.getFilterValueByCode(availableFilters, filterTypeVehicles.TRANSMISSIONS, transmissions)) {
      this._handleValueChange('transmissions', transmissions);
    }

    this.props.filterVehicles()
  }

  _handleValueChange = (prop, value) => {
    this.props.setVehiclesState({ prop, value });
  };

  _handleClearFilters = () => {
    this._handleValueChange('colors', []);
    this._handleValueChange('fuels', []);
    this._handleValueChange('transmissions', []);
    this._handleValueChange('product_lines', []);
    this._handleValueChange('models', []);
    this._handleValueChange('specialPrice', false);
    this._handleValueChange('price', 0);
    this._handleValueChange('priceMin', 0);
    this._handleValueChange('cuota', 0);
    this._handleValueChange('cuotaMin', 0);
    this.props.filterVehicles();
    setTimeout(() => refreshSelectPicker(), 0);
  };

  _handleValueChangeAndFilter = (prop, value) => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    if (prop === filterTypeVehicles.COLORS && !Array.isArray(value)) {
      let { colors } = this.props;
      this._handleValueChange(prop, VehiclesManager.pushColor(colors, value).slice());
    } else {
      this._handleValueChange(prop, value);
    }
    this.props.filterVehicles();
    //startCarousel();
  };

  async _loadVehicles() {
    const { location, match } = this.props;
    if (location && location.pathname && location.pathname.includes('search=')) {
      await this._apiGetVehiclesSearch();
      return;
    }if (match && match.path.includes(Routing.vehiclePromotion)) {
      await this._apiGetVehiclePromotion();
      return;
    }
    await this._apiGetVehicles();
  }

  _onClickAccept() {
    const { history } = this.props;
    history.replace(Routing.comparator);
  }

  _renderVehicleEmptyList() {
    const { dataVehiclesOriginal, isLoadingVehicles } = this.props;

    if (isLoadingVehicles) {
      return (
        <div className='w-100 my-5 py-5'>
          <Loading />
        </div>
      )
    }

    if (!dataVehiclesOriginal || (dataVehiclesOriginal && dataVehiclesOriginal.length === 0) && !isLoadingVehicles) {
      // TODO change text to fire
      return <div className='d-flex w-100 justify-content-center flex-column align-items-center px-4'>
        {/* noStockPageTitle from this.props */}
        {/* <div className='h4 text-primary'>{noStockPageTitle ? noStockPageTitle : strings('vehicles.emptyList')}</div> */}
        <div className='h4 text-primary'>{strings('vehicles.emptyList')}</div>
        <p className='fs-1 text-center' style={{maxWidth: '600px',textAlign: 'justify', fontSize: 'large'}}>
         {/* noStockPageMessage from this.props */}
         {/* {noStockPageMessage ? noStockPageMessage : strings('vehicles.soonBackInStock')} */}
         {strings('vehicles.soonBackInStock')}
        </p>
        <Link to={Routing.contact} className='btn btn-primary text-uppercase mt-2'>
          {strings('vehicles.contactAdvisor')}
        </Link>
      </div>
    }
  }

  _renderVehicleList() {
    const { dataVehicles, dataVehiclesOriginal, isLoadingVehicles, listBottomText, h2ModelBottom, currentModelDescription, dataComparator } = this.props;

    if (isLoadingVehicles) {
      return (
        <div />
      )
    }

    if (!dataVehiclesOriginal || (dataVehiclesOriginal && dataVehiclesOriginal.length === 0) && !isLoadingVehicles) {
      return <div />
    }

    if (dataVehicles && dataVehicles.length === 0) {
      return <div className='d-flex w-100 justify-content-center'>{strings('vehicles.emptyListFilter')}</div>
    }

     const dataRenderVehicles = dataVehicles.map((item, index) => {
        const id = VehiclesManager.getVin(item);
        const modelGroupDescription = VehiclesManager.getModelGroupDescription(item);
        const productLineDescription = VehiclesManager.getProductLineDescription(item);
        const gearboxDescription = VehiclesManager.getGearboxDescription(item);
        const fuelDescription = VehiclesManager.getFuelDescription(item);
        const colorDescription = VehiclesManager.getColorDescription(item);
        const finalPrice = VehiclesManager.getFinalPrice(item);
        const finalPriceFormat = VehiclesManager.getFinalPriceFormat(item);
        const price = VehiclesManager.getPrice(item);
        const priceFormat = VehiclesManager.getPriceFormat(item);
        const images = VehiclesManager.getImagesList(item);
        const cuotaPriceFormat = VehiclesManager.getCuotaPriceFormat(item);
        const power = VehiclesManager.getPower(item);
        const hasSpecialPrice = VehiclesManager.getHasSpecialPrice(item);
        const tags = VehiclesManager.getTags(item);

        return (
          <VehiclesItems
            key={index}
            item={item}
            id={id}
            modelGroupDescription={modelGroupDescription}
            productLineDescription={productLineDescription}
            gearboxDescription={gearboxDescription}
            fuelDescription={fuelDescription}
            colorDescription={colorDescription}
            finalPrice={finalPrice}
            finalPriceFormat={finalPriceFormat}
            price={price}
            priceFormat={priceFormat}
            images={images}
            cuotaPriceFormat={cuotaPriceFormat}
            power={power}
            hasSpecialPrice={hasSpecialPrice}
            addComparator={() => this._addComparator(item)}
            vehiclesIsComparator={dataComparator.find((element)=> id === VehiclesManager.getVin(element))}
            showModal={() => {
              this.setState({vehicle: item})
            }}
            tags={tags}
          />
        )
      })

    return (
      <>
        {dataRenderVehicles}
        {currentModelDescription ? <h2>{h2ModelBottom}</h2> : <></>}
        <p className='text-muted text-center pt-4'>{listBottomText}</p>
      </>

    )
  }

  _renderVehicleFilter() {
    const {
      availableFilters, dataVehicles, isLoadingVehicles, maxPrice, minPrice,
      colors, fuels, transmissions, price, priceMin, specialPrice, maxCuota, minCuota, cuota, cuotaMin, product_lines, models
    } = this.props;

    if ((dataVehicles && dataVehicles.length === 0) && (availableFilters && availableFilters.length === 0) || isLoadingVehicles) {
      return <div />
    }

    return (
      <VehiclesFilter
        availableFilters={availableFilters}
        onChange={(prop, value) => this._handleValueChangeAndFilter(prop, value)}
        onClearFilters={this._handleClearFilters}
        maxPrice={maxPrice}
        minPrice={minPrice}
        colors={colors}
        fuels={fuels}
        transmissions={transmissions}
        product_lines={product_lines}
        models={models}
        price={price}
        priceMin={priceMin}
        specialPrice={specialPrice}
        maxCuota={maxCuota}
        minCuota={minCuota}
        cuota={cuota}
        cuotaMin={cuotaMin}
      />
    )
  }

  _renderVehicleModalComparator() {
    const {vehiclesCompareMax} = this.props;
    return (
      <Modal
        body={strings('modals.comparatorFull.body', {value: vehiclesCompareMax})}
        classBody=''
        classBtnAccept='btn btn-primary'
        classBtnCancel='btn btn-secondary'
        idModal='modalAddComparator'
        onClickAccept={() => {
          if(closeModalBackdrop) {
            closeModalBackdrop();
          }
          this._onClickAccept();
        }}
        showBtnCancel={false}
        txtAccept={strings('modals.comparatorFull.txtAccept')}
        txtCancel={strings('modals.comparatorFull.txtCancel')}
        title={strings('modals.comparatorFull.title')}
      />
    )
  }

  _renderTopBar() {
    const { currentModelDescription, vehiclesCount, isLoadingVehicles, currentModelH2Label, currentModelH1 } = this.props;


    if (isLoadingVehicles || vehiclesCount === 0) {
      return (<div />)
    }

    const name = currentModelDescription ? currentModelDescription : strings('title.vehicles')

    return (
     <div id="filters" className="mt-0 mb-3 p-0">
        <div className="form-row d-flex align-items-center">

          {vehiclesCount !== 0 && (
            <div className="col-lg-9 align-items-center justify-content-center justify-content-lg-start mb-2 mb-lg-3 text-lg-start">
              <div>
                <div className="h3 mb-0 text-secondary mr-2 d-none d-lg-inline-flex">{vehiclesCount ? vehiclesCount : 0}</div>
                <h1 className="h3 mb-0 text-primary d-inline-block">{currentModelH1 ? currentModelH1 : `${name} ${strings('vehicles.newInStock')}`}</h1>
              </div>
              <h2 className='h4 mb-0 text-secondary'>{currentModelH2Label}</h2>

          </div>
          )}

          {vehiclesCount !==0 ?
            <>
            <div className="col-lg-3">
              <div className="dropdown m-0 d-none d-lg-block">
                <button className="btn btn-link ml-auto px-0" type="button" data-toggle="dropdown"
                        aria-expanded="false">
                  {this._getTextsSelect()}
                  <ImageSvg src={getAsset('icSortDown')}/>
                </button>
                <div className="dropdown-menu dropdown-menu-right">

                  <Link to={Routing.nowhere} className="dropdown-item" onClick={() => {
                    this._onSelect('1')
                  }}>
                    {strings('vehicles.highestPrice')}
                  </Link>

                  <Link to={Routing.nowhere} className="dropdown-item"  onClick={() => {
                    this._onSelect('2')
                  }}>
                    {strings('vehicles.lowestPrice')}
                  </Link>

                  <Link to={Routing.nowhere} className="dropdown-item"  onClick={() => {
                    this._onSelect('3')
                  }}>
                    {strings('vehicles.offersPromotions')}
                  </Link>
                </div>
              </div>
            </div>
            </>
            :
            <div/>
            }
            </div>
            </div>
            )
          }

          async _onSelect(value) {
          this.setState({inputOrderValue: value})
          switch (value) {
          case '1':
          this.props.orderByMorePrice();
          break;
          case '2':
          this.props.orderByLowerPrice();
          break;
          case '3':
          this.props.orderByOffersAndPromotions();
          break;

        }

        }

        _getTextsSelect() {
          const value = this.state.inputOrderValue

          if (value === '0'){
            return strings('vehicles.sortBy')
          } else if (value === '1'){
            return strings('vehicles.sortBy')
          }else if (value === '2'){
            return strings('vehicles.lowestPrice')
          }else if (value === '3'){
            return strings('vehicles.offersPromotions')
          }

          return ''
        }

          _orderByLowerPrice() {
          this.props.orderByLowerPrice();
        }
          }

const mapStateToProps = ({AppReducer, ComparatorReducer, VehiclesReducer }) => {
  const { vehiclesCompareMax, listBottomText, metasModelTitle, metasModelDescription, cookiesBannerScript, metricsGtmEnabled, metricsGtmId, noStockPageTitle, noStockPageMessage } = AppReducer;
  const {
    availableFilters, dataVehicles, dataVehicleDetail, dataVehiclesOriginal, isLoadingVehicles, vehiclesCount, maxPrice, minPrice,
    colors, fuels, transmissions, price, priceMin, specialPrice, currentModelDescription, maxCuota, minCuota, cuota, cuotaMin, currentModelH2Label, currentModelH2Paragraph, currentModelH1, product_lines, models,
    h2ModelBottom
  } = VehiclesReducer;
  const { dataComparator } = ComparatorReducer;

  return {
    vehiclesCompareMax,listBottomText, metasModelTitle, metasModelDescription, cookiesBannerScript, metricsGtmEnabled, metricsGtmId,
    dataComparator,
    availableFilters, dataVehicles, dataVehicleDetail, dataVehiclesOriginal, isLoadingVehicles, vehiclesCount, maxPrice, minPrice,
    colors, fuels, transmissions, price, priceMin, specialPrice, currentModelDescription, maxCuota, minCuota, cuota, cuotaMin, currentModelH2Label, currentModelH2Paragraph, currentModelH1,
    noStockPageTitle, noStockPageMessage, h2ModelBottom, product_lines, models
  }
};

const mapStateToPropsAction = {
  addToast,
  addComparator,
  apiGetVehicles,
  apiGetVehiclePromotion,
  apiGetVehiclesSearch,
  clearDataVehicles,
  setVehiclesState,
  orderByMorePrice,
  orderByLowerPrice,
  orderByOffersAndPromotions,
  filterVehicles
};

export default connect(mapStateToProps, mapStateToPropsAction)(VehiclesContainer);
